import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Box, Typography } from '@mui/material';
// components
import { useChart } from 'components/chart';

import i18n from 'i18';
import WidgetWrapper from './wrappers/WidgetWrapper';
import StyledChartWrapper from './wrappers/ChartWrapper';
AppMonthlyTransactionVolumeChart.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    color: PropTypes.string,
    chartInfoTitle: PropTypes.string,
    chartInfoSubtitle: PropTypes.string,
    chartData: PropTypes.array.isRequired,
    chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired
};
const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];

export default function AppMonthlyTransactionVolumeChart({
    title,
    subtitle = '',
    chartLabels,
    chartData,
    color = 'light',
    sx,
    chartInfoTitle,
    chartInfoSubtitle
    // ...other
}) {
    const monthsLabels = chartLabels.map((date) => {
        const [, month] = date.split('-');
        return monthNames[parseInt(month, 10) - 1] || '';
    });
    const chartOptions = useChart({
        chart: {
            type: 'line',
            height: 350,
            zoom: {
                enabled: false
            }
        },
        grid: {
            show: true,
            strokeDashArray: 0,
            borderColor: '#CFE3FF',
            xaxis: {
                lines: {
                    show: true
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            }
        },
        stroke: {
            width: 4,
            curve: 'smooth',
            dashArray: 0
        },
        markers: {
            size: 0, // Set size to 0 to hide markers
            // colors: ['#fff'],
            strokeColors: chartData.map((i) => i.color),
            colors: chartData.map((i) => i.color),
            strokeWidth: 2,
            hover: {
                size: 0
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                gradientToColors: chartData.map((i) => i.endColor),
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.9,
                stops: [0, 50, 100]
            }
        },
        labels: monthsLabels,
        xaxis: {
            categories: monthsLabels /* issue with Safari on iOS17 */
            /*type: 'datetime'*/
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: (y) => {
                    if (typeof y !== 'undefined') {
                        return `${y.toFixed(0)} ${i18n.t(
                            'dashboard.transactions'
                        )}`;
                    }
                    return y;
                }
            }
        },
        legend: {
            position: 'bottom',
            showForSingleSeries: true
        },
        colors: chartData.map((i) => i.color)
    });

    return (
        <WidgetWrapper
            title={title}
            subheader={subtitle}
            sx={{
                backgroundColor: (theme) => theme.palette.background.default,
                pb: 1
            }}
        >
            <Box
                sx={{
                    p: 3,
                    pb: 1
                }}
                dir="ltr"
            >
                <Box sx={{ mt: 2 }}>
                    <Typography variant="body1">
                        {chartInfoTitle && chartInfoTitle}
                    </Typography>
                    <Typography variant="subtitle2">
                        {chartInfoSubtitle && chartInfoSubtitle}
                    </Typography>
                </Box>

                <StyledChartWrapper>
                    <ReactApexChart
                        type="line"
                        series={chartData}
                        options={chartOptions}
                        height={265}
                    />
                </StyledChartWrapper>
            </Box>
        </WidgetWrapper>
    );
}
